var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.Post.Category.View", ["require", "exports", "Backbone", "sc_blog_post_category.tpl", "SuiteCommerce.Blog.Common", "SuiteCommerce.Blog.BlogHome.Configuration"], function (require, exports, Backbone_1, categoryTemplate, Common_1, BlogHome_Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.PostCategoryView = void 0;
    var PostCategoryView = /** @class */ (function (_super) {
        __extends(PostCategoryView, _super);
        function PostCategoryView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = categoryTemplate;
            _this.model.on('change', function () {
                _this.render();
            });
            return _this;
        }
        PostCategoryView.prototype.getContext = function () {
            return {
                blogPageTitle: BlogHome_Configuration_1.BlogHomeConfiguration.blogHomeTitle,
                blogPageUrl: Common_1.BLOG_URL_BASE,
                category: this.model.category,
                categoryName: this.model.categoryName,
                categoryURL: this.model.categoryURL,
            };
        };
        return PostCategoryView;
    }(Backbone_1.View));
    exports.PostCategoryView = PostCategoryView;
});
